// 注意: 出码引擎注入的临时变量默认都以 "__$$" 开头，禁止在搭建的代码中直接访问。
// 例外：react 框架的导出名和各种组件名除外。
import React from "react";
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';


import { LayoutComponent } from "@ifeng/lowcode_basic/src/components/layout/LayoutComponent/index.tsx";

import { ImageLink } from "@ifeng/lowcode_basic/src/components/popular/ImageLink/index.tsx";

import { Nav_1 } from "@ifeng/lowcode_basic/src/components/nav/Nav_1/index.tsx";

import { Container } from "@ifeng/lowcode_basic/src/components/layout/Container/index.tsx";

import { Row } from "@ifeng/lowcode_basic/src/components/layout/Row/index.tsx";

import { Col } from "@ifeng/lowcode_basic/src/components/layout/Col/index.tsx";

import { Title } from "@ifeng/lowcode_basic/src/components/popular/Title/index.tsx";

import { NewsList_1 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_1/index.tsx";

import { Swiper_1 } from "@ifeng/lowcode_basic/src/components/Swiper/Swiper_1/index.tsx";

import { VideoList_1 } from "@ifeng/lowcode_basic/src/components/video/VideoList_1/index.tsx";

import { Tabs } from "@ifeng/lowcode_basic/src/components/layout/Tabs/index.tsx";

import { TabPanel, Swiper_5 } from "@ifeng/lowcode_basic/src/index.tsx";

import { NewList_9 } from "@ifeng/lowcode_business/src/components/newList/NewList_9/index.tsx";

import { NewsList_12 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_12/index.tsx";

import { Comment } from "@ifeng/lowcode_basic/src/components/popular/Comment/index.tsx";

import { Footer } from "@ifeng/lowcode_basic/src/components/popular/Footer/index.tsx";

import utils from "../../utils";

import "./index.css";

class Layout$$Page extends React.Component {
  _context = this;

  constructor(props, context) {
    super(props);

    this.utils = utils;

    this.state = {};
  }

  $ = () => null;

  $$ = () => [];

  componentDidMount() {}

  render() {
    const __$$context = this._context || this;
    const { state } = __$$context;
    return (
      <div
        style={{ overflowX: "hidden" }}
        hoverStyle=""
        nodeId="node_dockcviv8fo1"
      >
        <LayoutComponent
          isCenter={true}
          nodeId="node_ocl8lkjm3v1i"
          hoverStyle=""
        >
          <ImageLink
            image="https://x0.ifengimg.com/ucms/2023_09/2BE589E561466CD67F7F3937606DC63868FED28E_size158_w1920_h350.jpg"
            url=""
            isBlock={true}
            width={300}
            height={350}
            objectFit="cover"
            style={{
              display: "block",
              backgroundPositionX: "center",
              backgroundPositionY: "center",
              backgroundSize: "cover",
            }}
            hoverStyle=""
            nodeId="node_ocl8mrdjw62"
          />
          <Nav_1
            navChip={{
              $data: true,
              id: "260571",
              type: "struct",
              title: "导航内容",
              default: { type: "struct", id: "260297" },
              uuid: "86b6f4dc",
              force: 1677599493094,
            }}
            mainWidth={1000}
            height={80}
            backgroundColor="#d41e26"
            isHasLeftImage={true}
            isSubTitleUnderline={true}
            subTitleHoverColor="#ffffff"
            subTitleStyle={{
              color: "#ffffff",
              fontSize: "16px",
              fontWeight: 400,
            }}
            titleStyle={{
              color: "#ffffff",
              fontSize: "24px",
              fontWeight: 700,
              lineHeight: "28px",
              width: "20px",
            }}
            leftImageUrl="https://x0.ifengimg.com/ucms/2022_42/F97C21F25CC12931F992999D5ABA015D2C64A8AF_size66_w1754_h417.png"
            leftImageStyle={{ marginRight: "80px" }}
            isSticky={false}
            style={{ paddingRight: "20px", paddingLeft: "20px" }}
            hoverStyle=""
            leftImageWidth={120}
            nodeId="node_ocl8mrdjw63"
          />
        </LayoutComponent>
        <Container
          width={1200}
          isCenter={true}
          hoverStyle=""
          nodeId="node_ocl8lkjm3v1n"
        >
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl8lkjm3v1o"
            hoverStyle=""
          >
            <Row
              isCenter={true}
              justifyContent="flex-start"
              alignItems="stretch"
              hoverStyle=""
              style={{ paddingBottom: "10px" }}
              nodeId="node_ocl8mrdjw64"
            >
              <Col
                width={{ size: 800, type: "px" }}
                style={{
                  paddingRight: "20px",
                  marginTop: "40px",
                  marginBottom: "20px",
                }}
                hoverStyle=""
                nodeId="node_ocl8u2cvve1g"
              >
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_09/8DC5593E654930C94ABF2217B207CB4EEA4F572F_size4_w780_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    fontWeight: 700,
                    fontSize: "26px",
                    marginRight: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    marginTop: "30px",
                    marginRight: "20px",
                    marginBottom: "20px",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                  }}
                  hoverStyle=""
                  isTextHasIcon={false}
                  nodeId="node_ocl8u2cvve1w"
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "287555",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "546d7ba6",
                    force: 1677743950323,
                  }}
                  hoverColor="#ba2636"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "26px",
                    fontWeight: 700,
                    lineHeight: "26px",
                    paddingBottom: "15px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{
                    fontSize: "14px",
                    lineHeight: "26px",
                    fontWeight: 400,
                  }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  hoverStyle=""
                  style={{ paddingRight: "20px" }}
                  itemStyle={{
                    paddingBottom: "24px",
                    marginTop: "24px",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    borderColor: "#dadada",
                  }}
                  nodeId="node_ocl96p0d0t3"
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "287556",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "f6abb15e",
                    force: 1677727893484,
                  }}
                  hoverColor="#ba2636"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "26px",
                    lineHeight: "26px",
                    fontWeight: 400,
                    marginBottom: "15px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{
                    fontSize: "14px",
                    lineHeight: "26px",
                    fontWeight: 400,
                  }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  style={{ paddingRight: "20px", paddingBottom: "20px" }}
                  hoverStyle=""
                  itemStyle={{
                    borderBottomStyleType: "solid",
                    borderBottomStyleColor: "#ebebeb",
                    marginTop: "24px",
                    borderStyle: "none",
                  }}
                  nodeId="node_ocl8u2cvve1o"
                />
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_09/AD42AB86DB762378BCE9751F43453FD729A30DAA_size4_w780_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#c33430",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    backgroundColor: "#ffffff",
                    marginRight: "20px",
                    marginBottom: "10px",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                  }}
                  hoverStyle=""
                  nodeId="node_ocl8u8dees9g"
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "287557",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "9fcd7c12",
                    force: 1677728036282,
                  }}
                  hoverColor="#ba2636"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "14px",
                    lineHeight: "26px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{ fontSize: "14px", lineHeight: "26px" }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  style={{ paddingRight: "20px" }}
                  hoverStyle=""
                  itemStyle={{
                    paddingBottom: "24px",
                    marginTop: "24px",
                    borderBottomWidth: "1px",
                    borderBottomStyle: "solid",
                    borderBottomColor: "#ebebeb",
                  }}
                  nodeId="node_ocl8u8dees9a"
                />
              </Col>
              <Col
                width={{ size: 380, type: "px" }}
                style={{ marginBottom: "20px", marginTop: "40px" }}
                hoverStyle=""
                nodeId="node_ocl8u2cvve1j"
              >
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_09/4584615CA13E5290DFC97CC2D06AC342582EDD36_size4_w380_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    marginTop: "30px",
                    height: "40px",
                    marginBottom: "20px",
                  }}
                  hoverStyle=""
                  nodeId="node_ocl8u2cvve23"
                />
                <Swiper_1
                  swiperChip={{
                    $data: true,
                    id: "287558",
                    type: "recommend",
                    title: "轮播图内容",
                    default: { type: "recommend", id: "285915" },
                    uuid: "9d6241df",
                    force: 1677728057293,
                  }}
                  height={213}
                  loop={false}
                  isHasNav={false}
                  leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                  rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                  navWidth={15}
                  navHeight={20}
                  navY={85}
                  navX={10}
                  isAutoPlay={true}
                  autoSpeed={3000}
                  skin={1}
                  isHasTitle={true}
                  titleHeight={36}
                  titleStyle={{
                    background: "linear-gradient(180deg,transparent,#000)",
                    color: "#fff",
                    fontSize: "14px",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  isHasPagination={false}
                  paginationPosition="titleBottom"
                  paginationNormalStyle={{
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    borderTopLeftRadius: "50px",
                    borderTopRightRadius: "50px",
                    borderBottomLeftRadius: "50px",
                    borderBottomRightRadius: "50px",
                    width: "4px",
                    height: "4px",
                    marginLeft: "4px",
                    marginRight: "4px",
                  }}
                  paginationActiveStyle={{
                    borderTopLeftRadius: "2px",
                    borderTopRightRadius: "2px",
                    borderBottomLeftRadius: "2px",
                    borderBottomRightRadius: "2px",
                    width: "12px",
                  }}
                  paginationTotalStyle={{ marginBottom: "10px" }}
                  style={{ paddingTop: "10px" }}
                  hoverStyle=""
                  nodeId="node_ocl8uc1v7t4"
                />
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_10/EA47F8812FDA806EDC66BE5CD9F3B90A0CC99B35_size6_w380_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{ marginTop: "20px", height: "40px" }}
                  hoverStyle=""
                  nodeId="node_ocl8u2cvve24"
                />
                <VideoList_1
                  videoChip={{
                    $data: true,
                    id: "287559",
                    type: "recommend",
                    title: "视频列表",
                    format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                    default: { type: "recommend", id: "285924" },
                    uuid: "e8ff8555",
                    force: 1678526081698,
                  }}
                  width={380}
                  height={213}
                  autoPlay={false}
                  controls={true}
                  hoverColor="#ba2636"
                  skin={0}
                  continuePlay={false}
                  style={{ marginTop: "20px" }}
                  listHeight={48}
                  listIcon="https://x2.ifengimg.com/fe/custom/xghg25/video.559ac347.png"
                  listIconWidth={14}
                  listIconHeight={9}
                  listStyle={{
                    paddingLeft: "0px",
                    paddingRight: "10px",
                    height: "36px",
                    fontSize: "14px",
                    color: "#2b2b2b",
                  }}
                  hoverStyle=""
                  nodeId="node_ocl8u2cvve1n"
                />
              </Col>
            </Row>
          </LayoutComponent>
        </Container>
        <Container
          width={1200}
          isCenter={true}
          hoverStyle=""
          nodeId="node_ocl988i9ym1"
        >
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl9899vnz1g2"
            hoverStyle=""
            style={{ paddingBottom: "10px" }}
          >
            <Title
              text=""
              height={50}
              image="https://x0.ifengimg.com/ucms/2023_10/ED23600444126ABF87BAB0B10DA456C3B0A17BC5_size11_w1192_h50.jpg"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "20px",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{
                marginBottom: "20px",
                fontSize: "36px",
                fontWeight: 700,
                color: "#ecebef",
                marginTop: "20px",
              }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm2"
            />
            <Tabs
              tabList={[
                { title: "政协发布会", id: "1" },
                {
                  id: "75c7ebf1-4af2-482d-a9e5-7a800fa98a1d",
                  title: "政协开幕",
                },
                { title: "人大发布会", id: "2" },
                {
                  id: "b53c23a2-4437-4823-9545-dcc50142c036",
                  title: "政府工作报告",
                },
                {
                  id: "e5cca4d3-4c49-4125-92f9-c810bab2ac42",
                  title: "总理记者会",
                },
              ]}
              tabWidth={250}
              tabHeight={40}
              tabGap={10}
              contentGap={20}
              tabStyle={{
                borderWidth: "1px",
                borderColor: "#c3c3c3",
                borderStyle: "solid",
                borderTopWidth: "1px",
                fontWeight: "400",
                fontSize: "20px",
              }}
              tabActiveStyle={{
                fontSize: "20px",
                fontWeight: "700",
                backgroundColor: "#c33430",
                color: "#ffffff",
              }}
              nodeId="node_ocleqpd025j"
              hoverStyle=""
            >
              <TabPanel panelId="1" nodeId="node_ocleqpd025k">
                <NewList_9
                  newsChip={{
                    $data: true,
                    id: "287666",
                    type: "recommend",
                    title: "新闻列表",
                    default: { type: "recommend", id: "287646" },
                    uuid: "bf701a32",
                    force: 1678107276733,
                  }}
                  bigImageWidth={793}
                  imageWidth={386}
                  nodeId="node_ocleqpd025q"
                  hoverColor="#ba2636"
                  hoverStyle=""
                  style={{ textAlign: "justify", marginBottom: "20px" }}
                />
              </TabPanel>
              <TabPanel
                panelId="75c7ebf1-4af2-482d-a9e5-7a800fa98a1d"
                nodeId="node_oclewqb1hv5"
                hoverStyle=""
              >
                <NewList_9
                  newsChip={{
                    $data: true,
                    id: "287682",
                    type: "recommend",
                    title: "新闻列表",
                    default: { type: "recommend", id: "287646" },
                    uuid: "838de48a",
                    force: 1678112949915,
                  }}
                  bigImageWidth={793}
                  imageWidth={386}
                  nodeId="node_ocleqpd025x"
                  hoverColor="#ba2636"
                  hoverStyle=""
                />
              </TabPanel>
              <TabPanel panelId="2" nodeId="node_ocleqpd025l">
                <NewList_9
                  newsChip={{
                    $data: true,
                    id: "287667",
                    type: "recommend",
                    title: "新闻列表",
                    default: { type: "recommend", id: "287646" },
                    uuid: "4b9af24e",
                    force: 1678108491353,
                  }}
                  bigImageWidth={793}
                  imageWidth={386}
                  nodeId="node_ocleqpd025x"
                  hoverColor="#ba2636"
                  hoverStyle=""
                />
              </TabPanel>
              <TabPanel
                panelId="b53c23a2-4437-4823-9545-dcc50142c036"
                nodeId="node_oclewqb1hv1"
                hoverStyle=""
              >
                <NewList_9
                  newsChip={{
                    $data: true,
                    id: "287681",
                    type: "recommend",
                    title: "新闻列表",
                    default: { type: "recommend", id: "287646" },
                    uuid: "6219fdf4",
                    force: 1678115633739,
                  }}
                  bigImageWidth={793}
                  imageWidth={386}
                  nodeId="node_ocleqpd025x"
                  hoverColor="#ba2636"
                  hoverStyle=""
                />
              </TabPanel>
              <TabPanel
                panelId="e5cca4d3-4c49-4125-92f9-c810bab2ac42"
                nodeId="node_oclf6ybcdj3"
              >
                <NewList_9
                  newsChip={{
                    $data: true,
                    id: "287698",
                    type: "recommend",
                    title: "新闻列表",
                    default: { type: "recommend", id: "287646" },
                    uuid: "24bcb295",
                    force: 1678720148283,
                  }}
                  bigImageWidth={793}
                  imageWidth={386}
                  nodeId="node_ocleqpd025x"
                  hoverColor="#ba2636"
                  hoverStyle=""
                />
              </TabPanel>
            </Tabs>
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl8u8dees77"
            hoverStyle=""
            style={{ paddingBottom: "20px" }}
          >
            <Title
              text=""
              height={50}
              image="https://x0.ifengimg.com/ucms/2023_09/61136057141102D7A53276BBE7CC3D018A1FE9F5_size9_w1192_h50.jpg"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "20px",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{
                fontSize: "36px",
                fontWeight: 700,
                color: "#ecebef",
                marginBottom: "20px",
                marginTop: "20px",
              }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm2"
            />
            <NewsList_12
              newsChip={{
                $data: true,
                id: "287561",
                type: "recommend",
                title: "新闻内容",
                default: { type: "recommend", id: "285873" },
                uuid: "fd6c9efe",
                force: 1677667014369,
              }}
              colNum={3}
              thumbnailWidth={383}
              thumbnailHeight={215}
              showThumbnailHoverScale={true}
              isHasTitle={true}
              titleRows={2}
              titleHoverColor="#ba2636"
              titleStyle={{
                paddingTop: "15px",
                paddingBottom: "15px",
                marginLeft: "20px",
                marginRight: "20px",
                borderBottomStyle: "solid",
                borderBottomWidth: "1px",
                borderBottomColor: "#e8e8e8",
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                marginBottom: "10px",
                textAlign: "justify",
              }}
              showSummary={true}
              summaryRows={3}
              summaryStyle={{
                paddingBottom: "15px",
                color: "#666666",
                fontSize: "14px",
                lineHeight: "20px",
                paddingTop: "10px",
                paddingLeft: "20px",
                paddingRight: "20px",
                textAlign: "justify",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#ba2636" }}
              itemStyle={{ border: "1px solid #e8e8e8" }}
              formatImageType={2}
              style={{ borderBottomStyle: "none", marginBottom: "20px" }}
              hoverStyle=""
              titleHeight={50}
              nodeId="node_ocl8u8xf684"
              skin={0}
            />
          </LayoutComponent>
        </Container>
        <LayoutComponent
          isCenter={true}
          nodeId="node_ocl988i9ym2"
          hoverStyle=""
        >
          <Title
            text=""
            height={50}
            image="https://x0.ifengimg.com/ucms/2023_09/86CAAD5E50C258E777BCD2A08806A3B6FFE43ECD_size8_w1192_h50.jpg"
            textAlign="flex-start"
            textStyle={{
              paddingLeft: "24px",
              fontWeight: 700,
              fontSize: "20px",
            }}
            isHasAddonAfter={false}
            addonAfterText="更多"
            addonAfterTextStyle={{
              fontSize: "14px",
              color: "#ffffff",
              textDecoration: "underline",
            }}
            style={{
              fontSize: "36px",
              fontWeight: "700",
              color: "#ecebef",
              width: "1200px",
              margin: "0 auto",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            isTextHasIcon={false}
            hoverStyle=""
            nodeId="node_ocl93sv4mm2"
          />
          <Swiper_5
            swiperChip={{
              $data: true,
              id: "287588",
              type: "recommend",
              title: "轮播图数据",
              default: { type: "recommend", id: "286116" },
              uuid: "3d775640",
              force: 1678275268555,
            }}
            swiperWidth={1200}
            height={595}
            formatImageType={0}
            isAutoPlay={true}
            autoSpeed={3000}
            isHasNav={true}
            leftNavImage="http://p2.ifengimg.com/l/2018/5/15a8462c875f75e/leftButton.png"
            rightNavImage="http://p1.ifengimg.com/l/2018/5/15a8462c875f75e/rightButton.png"
            navWidth={57}
            navHeight={64}
            navY={220}
            navX={1250}
            isHasTitle={true}
            titleLeft={0}
            titleRight={0}
            titleY={60}
            titleStyle={{
              color: "#ffffff",
              fontSize: "20px",
              lineHeight: "28px",
              backgroundColor: "rgba(0, 0, 0, 0.65)",
              paddingTop: "15px",
              paddingRight: "20px",
              paddingBottom: "15px",
              paddingLeft: "20px",
            }}
            hoverStyle=""
            style={{ marginBottom: "20px" }}
            nodeId="node_ocl8u8dees97"
          />
        </LayoutComponent>
        <Container
          isCenter={true}
          nodeId="node_oclejrhbo23i"
          hoverStyle=""
          width={1200}
        >
          <LayoutComponent
            isCenter={true}
            nodeId="node_oclepsnb3t1"
            hoverStyle=""
          >
            <Title
              text=""
              height={50}
              image="https://x0.ifengimg.com/ucms/2023_09/06DA9FA49D65756DB5B08C50E9F652C625DF32C1_size10_w1192_h50.jpg"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "20px",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{
                fontSize: "36px",
                fontWeight: "700",
                color: "#ecebef",
                width: "1200px",
                margin: "0 auto",
                marginBottom: "20px",
                marginTop: "20px",
              }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm2"
            />
            <NewsList_12
              newsChip={{
                $data: true,
                id: "287663",
                type: "recommend",
                title: "新闻内容",
                default: { type: "recommend", id: "285873" },
                uuid: "8d4056c2",
                force: 1677729633928,
              }}
              colNum={3}
              thumbnailWidth={383}
              thumbnailHeight={215}
              showThumbnailHoverScale={true}
              isHasTitle={true}
              titleRows={2}
              titleHoverColor="#ba2636"
              titleStyle={{
                paddingTop: "15px",
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                marginBottom: "10px",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
              showSummary={true}
              summaryStyle={{
                color: "#666666",
                fontSize: "15px",
                lineHeight: "26px",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#ba2636" }}
              itemStyle={{
                borderColor: "#ebebeb",
                borderWidth: "1px",
                borderStyle: "solid",
              }}
              formatImageType={2}
              nodeId="node_ocl89zej7q1n"
              hoverStyle=""
              style={{ marginBottom: "20px" }}
              summaryRows={3}
            />
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl9ksctaz1"
            hoverStyle=""
            style={{}}
          >
            <Title
              text=""
              height={50}
              image="https://x0.ifengimg.com/ucms/2023_09/40FFD3EA7CC1F6A0FC37AD533705934A80275AF8_size8_w1192_h50.jpg"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "20px",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{
                marginBottom: "20px",
                fontSize: "36px",
                fontWeight: 700,
                color: "#ecebef",
                marginTop: "20px",
              }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm2"
            />
            <NewsList_12
              newsChip={{
                $data: true,
                id: "287600",
                type: "recommend",
                title: "新闻内容",
                default: { type: "recommend", id: "285873" },
                uuid: "bcc55d4e",
                force: 1677748501757,
              }}
              colNum={3}
              thumbnailWidth={383}
              thumbnailHeight={215}
              showThumbnailHoverScale={true}
              isHasTitle={true}
              titleRows={2}
              titleHoverColor="#ba2636"
              titleStyle={{
                paddingTop: "15px",
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                marginBottom: "10px",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
              showSummary={true}
              summaryStyle={{
                color: "#666666",
                fontSize: "15px",
                lineHeight: "26px",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
              moreText=""
              moreStyle={{ color: "#ba2636" }}
              itemStyle={{
                borderColor: "#ebebeb",
                borderWidth: "1px",
                borderStyle: "solid",
              }}
              formatImageType={2}
              nodeId="node_ocl89zej7q1n"
              hoverStyle=""
              style={{ marginBottom: "20px" }}
              summaryRows={3}
            />
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl97sakbr1i"
            hoverStyle=""
            style={{ paddingBottom: "20px", marginTop: "30px" }}
          >
            <Title
              text=""
              height={50}
              image="https://x0.ifengimg.com/ucms/2023_09/5FE800BBB8A8055F6AE2CED5C1F47D7CDD262ABA_size9_w1192_h50.jpg"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "20px",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{
                marginBottom: "20px",
                marginTop: "20px",
                backgroundColor: "#c33430",
                fontSize: "36px",
                fontWeight: 700,
                color: "#ecebef",
              }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm2"
            />
            <Comment
              url="https://news.ifeng.com/loc/mainland/special/20th"
              title="中共二十大"
              hoverStyle=""
              style={{ marginBottom: "20px" }}
              nodeId="node_ocl8u8xf681"
            />
          </LayoutComponent>
          <Container isCenter={true} nodeId="node_oclepbo85c4" hoverStyle="">
            <Title
              text=""
              height={50}
              image="https://x0.ifengimg.com/ucms/2023_09/0E6B210E2B2866F9881A0C44C8B112DE9DC84D9B_size8_w1192_h50.jpg"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "20px",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{
                marginBottom: "20px",
                marginTop: "20px",
                backgroundColor: "#c33430",
                fontSize: "36px",
                fontWeight: 700,
                color: "#ecebef",
              }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm2"
            />
            <Container
              isCenter={true}
              nodeId="node_oclepbo85c5"
              hoverStyle=""
              style={{ textAlign: "center", margin: "40px 0 40px" }}
            >
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_09/613A8F651AA644237166524E775A86AF3AC647EC_size377_w7000_h1363.png"
                url=""
                isBlock={false}
                width={550}
                objectFit=""
                nodeId="node_oclepbo85c6"
                hoverStyle=""
                style={{ height: "auto" }}
                height={300}
              />
            </Container>
            <Container
              isCenter={true}
              nodeId="node_oclepbo85c7"
              hoverStyle=""
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_09/EE3688E09CBC47F6DEBC31B9C53A66D71128866B_size180_w1500_h600.png"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={300}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_09/A523E9694CD2B34649C526D5D84F50AA5752DD02_size145_w1500_h600.png"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={300}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_09/EDC8AA7D0BCBA317CA686225EBEEB476991682E0_size289_w1500_h600.png"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={300}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_10/C1D7F7BC42082FC63BAB9C6F2683832E20EF42A8_size154_w1500_h600.png"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={300}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_09/A1C54AE845676CB2C80081539798D2E5B2C9AC30_size209_w1500_h600.png"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={200}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_10/3045AB05772184F2B889219AE802F1C9B65326D0_size43_w1500_h600.jpg"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={200}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_11/66ADBB12979EBEC863D486E6D5F60F532AA6738E_size58_w1500_h600.jpg"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={200}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_11/064812E408065E923E7F31EAD9AC7268F98A6911_size109_w1500_h600.jpg"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={200}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_11/32852B1A7C2C3ABBA3653CC386FF22E2D44AAF9A_size54_w1500_h600.jpg"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={200}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_11/C8C8CBB810F93816B8C743260782DAE18C8012D8_size20_w1500_h600.jpg"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                  display: "inline",
                }}
                height={200}
              />
              <ImageLink
                image=""
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={200}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_11/A3836B6B2214D84DC4213B5B665843FC6D203DBA_size11_w1500_h600.jpg"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{ height: "auto" }}
                height={200}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_10/A3836B6B2214D84DC4213B5B665843FC6D203DBA_size11_w1500_h600.jpg"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{ height: "auto", marginBottom: "26px" }}
                height={200}
              />
            </Container>
          </Container>
        </Container>
        <Footer
          year="2022"
          style={{ marginTop: "70px" }}
          hoverStyle=""
          textColor="#212223"
          nodeId="node_ocl8u8dees9i"
        />
      <ChipEdit transform={chipDataTransform} />
</div>
    );
  }
}

export default Layout$$Page;

function __$$eval(expr) {
  try {
    return expr();
  } catch (error) {}
}

function __$$evalArray(expr) {
  const res = __$$eval(expr);
  return Array.isArray(res) ? res : [];
}

function __$$createChildContext(oldContext, ext) {
  const childContext = {
    ...oldContext,
    ...ext,
  };
  childContext.__proto__ = oldContext;
  return childContext;
}
